import { useFrame } from "@react-three/fiber";
import { Text, Cylinder } from '@react-three/drei';
import { useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { cameraActions } from "../redux/cameraSlice";
import { interactionActions } from "../redux/interactionSlice";
import { IconInteractionMetadata } from "../models/Model3D";

// https://pictogrammers.com/library/mdi/
const mdiFontUrl = 'fonts/materialdesignicons-webfont.ttf'
export type InteractionElementFloatingIconProps = {
  interaction: IconInteractionMetadata;
}

type IconSpec = {
  unicode: string;
}

const icons: Record<string, IconSpec> = {
  search: { unicode: 'F0349' },
  enter: { unicode: 'F0FC4' },
  exit: { unicode: 'F0FC5' },
  openDoor: { unicode: 'F1C81' },
  closeDoor: { unicode: 'F109D' }
}

export const InteractionElementFloatingIcon = (props: InteractionElementFloatingIconProps) => {
  const { icon, action } = props.interaction;
  const [isHovered, setIsHovered] = useState(false);
  const boxRef = useRef<any>();
  const dispatch = useDispatch();


  useFrame(({ camera }) => {
    if (boxRef.current) {
      boxRef.current.lookAt(camera.position);
    }
  });

  const displayUnicode = useMemo(() => {
    const codePointHex = icons[icon.name]?.unicode || "F02D6";
    const codePointNumber = parseInt(codePointHex, 16);
    const unicodeCharacter = String.fromCodePoint(codePointNumber);
    return unicodeCharacter;
  }, [icon.name])
  const iconCode = icons[icon.name as any]?.unicode || 'eb8b'; // default to question mark


  const onClick = () => {
    // for some reason if you click on the label, it will trigger this twice?
    if (action?.toggleStates) {
      dispatch(interactionActions.toggleStates(action.toggleStates))
    }
    if (action?.setStates) {
      dispatch(interactionActions.setState(action.setStates))
    }
    if (action?.moveCamera !== undefined) {
      dispatch(cameraActions.setTargetPoint(action.moveCamera))
    }
    if (action?.boundary !== undefined) {
      dispatch(interactionActions.setBoundary(action.boundary))
    }
  }

  return <mesh ref={boxRef} position={icon.position} onPointerEnter={() => setIsHovered(true)} onPointerLeave={() => setIsHovered(false)} onClick={onClick}>
    <Cylinder args={[0.1, 0.1, 0.1]} rotation={[Math.PI / 2, 0, 0]} >
      <meshBasicMaterial color='yellow' transparent opacity={isHovered ? 1 : 0.6} />
    </Cylinder>
    <Text font={mdiFontUrl} fontSize={0.1} color='black' anchorX='center' anchorY='middle' position={[0, 0, 0.1]} onClick={(event) => {
      // preventing double trigger event: text and box geometry
      event.stopPropagation();
      onClick();
    }}>
      {displayUnicode}
    </Text>
  </mesh>
}